export default __webpack_public_path__ + "static/media/UploadedKyc.d6327440.svg";